/**
 * Emisión fiscal síncrona para imprimir el comprobante en el momento del cobro.
 * `arca-invoice` devuelve CAE en la respuesta (y es idempotente: si la venta ya
 * tiene comprobante aprobado devuelve el existente). Si ARCA tarda más que el
 * timeout, devuelve null — la emisión sigue server-side y el retry sweep la
 * completa; el comprobante se reimprime después desde Ventas.
 */
import { retryFiscalInvoiceEmit, type FiscalInvoiceEmitResult } from '../infra/fiscalRepository';

const EMIT_AWAIT_TIMEOUT_MS = 15_000;

export async function emitFiscalInvoiceAwaitingCae(
  saleId: string,
  timeoutMs = EMIT_AWAIT_TIMEOUT_MS
): Promise<FiscalInvoiceEmitResult | null> {
  let timedOut = false;
  const timeout = new Promise<null>((resolve) => {
    setTimeout(() => {
      timedOut = true;
      resolve(null);
    }, timeoutMs);
  });
  try {
    const result = await Promise.race([retryFiscalInvoiceEmit(saleId), timeout]);
    if (timedOut || !result) {
      if (timedOut) {
        console.warn('[fiscal] emit await timed out — la factura sigue en emisión');
      }
      return null;
    }
    return result.cae?.trim() || result.status === 'approved' ? result : null;
  } catch (err) {
    console.warn('[fiscal] emit for print failed', err);
    return null;
  }
}
